<gan-spinner></gan-spinner>

<gan-add-to-home-screen [displayBanner]="!!(msAccount$ | async)"></gan-add-to-home-screen>

<router-outlet></router-outlet>

<gan-notification></gan-notification>
